import { render, staticRenderFns } from "./NfeCardWallet.vue?vue&type=template&id=36b63346&scoped=true&"
import script from "./NfeCardWallet.vue?vue&type=script&lang=js&"
export * from "./NfeCardWallet.vue?vue&type=script&lang=js&"
import style0 from "./NfeCardWallet.vue?vue&type=style&index=0&id=36b63346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b63346",
  null
  
)

export default component.exports